// @ts-check
import { useCallback, useState, useEffect, useRef } from 'react';

/**
 * Triggers changes on reloadTrigger when reload() is called
 * @param {number} [otherReloadTrigger] - Other reload trigger to listen to, used for chaining reload triggers. If changed, reload() is called
 * @returns {[reloadTrigger: number, reload: () => void]}
 */
const useReloadTrigger = otherReloadTrigger => {
  const [reloadTrigger, setReloadTrigger] = useState(0);
  const reload = useCallback(() => setReloadTrigger(prev => prev + 1), []);
  const isInitialCall = useRef(true);

  useEffect(() => {
    if (isInitialCall.current) {
      isInitialCall.current = false;
    } else {
      reload();
    }
  }, [otherReloadTrigger, reload]);

  return [reloadTrigger, reload];
};

export default useReloadTrigger;
